var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChildrensCharities = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Baby-Hold-Hands--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Baby Hold Hands Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.23 6.85a0.76 0.76 0 0 0 -1 0.27 0.22 0.22 0 0 1 -0.4 0 0.75 0.75 0 1 0 -1.29 0.76 1.71 1.71 0 0 0 3 0 0.75 0.75 0 0 0 -0.31 -1.03Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.75a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.75a1 1 0 1 0 2 0 1 1 0 1 0 -2 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12 15.84a1.4 1.4 0 0 0 -0.45 1.82L5 19.88a0.49 0.49 0 0 1 -0.17 0.68 0.5 0.5 0 0 1 -0.69 -0.17l-1.35 -2.25a2.46 2.46 0 0 1 0.13 -2.48 0.54 0.54 0 0 0 0.08 -0.28V12.5a1.5 1.5 0 0 0 -3 0v5.17a4.5 4.5 0 0 0 1 2.81l2.66 3.33A0.49 0.49 0 0 0 4 24h4a0.5 0.5 0 0 0 0.5 -0.5v-3a4.46 4.46 0 0 0 -0.76 -2.5c-1.88 -2 -2.47 -2.93 -3.62 -2.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11a1.5 1.5 0 0 0 -1.5 1.5v2.88a0.54 0.54 0 0 0 0.08 0.28 2.46 2.46 0 0 1 0.13 2.48l-1.35 2.25a0.5 0.5 0 0 1 -0.69 0.17 0.49 0.49 0 0 1 -0.17 -0.68l1.33 -2.22a1.4 1.4 0 0 0 -0.45 -1.82c-1.15 -0.77 -1.74 0.18 -3.62 2.15a4.46 4.46 0 0 0 -0.76 2.5v3a0.5 0.5 0 0 0 0.5 0.5h4a0.49 0.49 0 0 0 0.39 -0.19L23 20.48a4.5 4.5 0 0 0 1 -2.81V12.5a1.5 1.5 0 0 0 -1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 8.45A9.84 9.84 0 0 0 18 6 6 6 0 0 0 6 6a9.84 9.84 0 0 0 0.42 2.45 26.52 26.52 0 0 1 0.83 5.05 4.75 4.75 0 0 0 9.5 0 26.52 26.52 0 0 1 0.83 -5.05ZM15.86 7a4 4 0 0 1 -7.72 0A3.73 3.73 0 0 1 8 6a4 4 0 0 1 8 0 3.73 3.73 0 0 1 -0.14 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChildrensCharities);
export default ForwardRef;